import { useQuery } from "@tanstack/react-query";
import { useRuntime } from "../runtime/RuntimeContext";
import type { RelatedCountResult } from "../../core";

// Batches the per-chip counter queries for the form-toolbar `Related ▾`
// dropdown (Enhancement 06). One query covers every chip in the open record's
// <related> block. Query key includes the activeId so a drill-pop to a
// different parent record naturally refetches. Re-uses the global
// `staleTime: 30_000` from QueryProvider — the broad ["record"] +
// ["action-records"] invalidation shipped in commit 51a1b65 already flushes
// these on any related-record mutation, so we don't need our own short stale.
export function useRelatedCounts(
    actionKeys: string[],
    activeId: string | undefined,
    enabled: boolean,
    activeModelKey?: string,
) {
    const runtime = useRuntime();
    // Stable cache key — sort to coalesce reorderings.
    const keys = actionKeys.slice().sort();
    return useQuery({
        queryKey: ["related-counts", activeId ?? "", activeModelKey ?? "", keys],
        queryFn: async (): Promise<RelatedCountResult[]> => {
            if (!activeId || keys.length === 0) return [];
            return runtime.services.action.relatedCounts(
                keys.map((actionKey) => ({ actionKey, activeId, activeModelKey })),
            );
        },
        enabled: enabled && Boolean(activeId) && keys.length > 0,
    });
}
